import type { FC } from "react";
import { useState } from "react";

import { FetchGet } from "@/lib/fetch-helper";
import type { IDiscountsPanel } from "@/src/discount/DiscountsPanel/DiscountsPanel";
import { useQueryCustomNoSuspense } from "@/src/query-client-overrides";
import { urlFormat } from "@Components/Modules/Helpers";
import type { IPanel } from "@Components/Panel";
import { Panel } from "@Components/Panel";
import { Common } from "@Routes/CommonLinks";

import type { ICategoriesCarouselItem } from "../common/CategoriesCarousel";
import { CategoriesCarousel } from "../common/CategoriesCarousel";
import DiscountsPanel from "../discount/DiscountsPanel";

import * as css from "./SearchCategories.module.css";

export interface ISearchCategories {
    panel: IPanel;
    discountsPanel: IDiscountsPanel;
    initialData: ICategoriesCarouselItem[];
}

export const SearchCategories: FC<ISearchCategories> = (props) => {
    const [selectedCategory, setSelectedCategory] = useState<string>(null);
    const endpoint = urlFormat(Common, { action: "CategoriesCarouselItems" });

    const { data } = useQueryCustomNoSuspense({
        queryKey: [endpoint],
        queryFn: () => FetchGet<ICategoriesCarouselItem[]>(endpoint),
        initialData: props.initialData,
    });

    if (!props.panel || !data) {
        return null;
    }

    const onCategoryClick = (category: ICategoriesCarouselItem) => setSelectedCategory(category.name);

    return (
        <div className={css.searchCategoriesComponent}>
            <Panel className={css.categoriesPanel} {...props.panel}>
                <CategoriesCarousel
                    categories={data}
                    trackerAction={
                        "/api/telemetry/Category?eventType=CategoryClick&id=%7Bid%7D&origin=Search"
                    }
                    onClick={onCategoryClick}
                />
            </Panel>
            {selectedCategory && (
                <DiscountsPanel
                    {...props.discountsPanel}
                    key={selectedCategory}
                    className={css.discountsPanel}
                    title={selectedCategory}
                />
            )}
        </div>
    );
};
